import { render, staticRenderFns } from "./tabulation.vue?vue&type=template&id=6b3e2cf3&scoped=true&"
import script from "./tabulation.vue?vue&type=script&lang=js&"
export * from "./tabulation.vue?vue&type=script&lang=js&"
import style0 from "./tabulation.vue?vue&type=style&index=0&id=6b3e2cf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e2cf3",
  null
  
)

export default component.exports